import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { setAppFooter as setAppFooterAction } from 'login-actions/layoutActions';
import DynamicUpdateComponent from './DynamicUpdateComponent';

interface AppFooterProps {
  footerConfig: FooterConfig | null;
  setAppFooter: (footerConfig: FooterConfig) => any;
}

class AppFooterUpdater extends React.Component<AppFooterProps, {}> {
  render() {
    const { footerConfig, setAppFooter, children } = this.props;
    return (
      <DynamicUpdateComponent value={footerConfig} dispatchFn={setAppFooter}>
        {children}
      </DynamicUpdateComponent>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ setAppFooter: setAppFooterAction }, dispatch);
};
export default connect(null, mapDispatchToProps)(AppFooterUpdater);
